<template>
  <div class="s-wrapper">

    <div v-if="isMobile" class="search-wrapper" :class="{'search-fixed': isSearchClass}">
      <div class="search-input" @click="showSearch">
          <i class="iconfont icon-sousuo"></i>
          <div class="input-tag"><span>{{ params.content ||  '搜索鲲鹏会学员'}}</span></div>
      </div>
    </div>

    <!-- 占位 -->
    <div v-if="isMobile && isSearchClass" class="search-wrapper">
      <div class="search-input">
          <input class="input-tag">
      </div>
    </div>
    <!-- 占位 -->

    <div v-if="isShowSearch || !isMobile" class="search-bar-wrap" :class="{'is-fixed': barFixed}" >
      <div class="search-bar">
        <!-- 搜索框 -->
        <div class="search-input">
          <i class="iconfont icon-sousuo"></i>
          <input class="input-tag" type="text" :value="params.content" @input="setInputWords" placeholder="搜索鲲鹏会学员">
        </div>

        <!-- 搜索当前条件 -->
        <div class="search-current" v-if="selectedConditions.length">
          <div class="search-bar-title">
            <h3 class="search-bar-h3">当前条件</h3>
            <h4 v-if="!isMobile" class="search-bar-h4" @click="clearAllCondition">清除条件</h4>
          </div>
          <div class="search-current-conditions">
            <div class="search-current-condition" :class="{'is-active':index===0}" v-for="(item, index) in selectedConditions" :key="index">
              <span class="search-current-name">{{item.selector.name}}</span>
              <i class="iconfont icon-close" @click="clearCondition(index)"></i>
            </div>
          </div>
        </div>

        <!-- 筛选条件 -->
        <div class="search-conditions">
          <div class="search-bar-title">
            <h3 class="search-bar-h3">搜索条件</h3>
          </div>
          <div class="search-conditions-bd">
            <div class="search-conditions-wrap" v-for="(item, idx) in allConditions" :key="idx">
              <div class="search-condition-item"
              :class="{'is-acitve': curCurrentidx === idx, 'is-hover': hoverCurrentIdx === idx && !item.isActive && curCurrentidx !== idx}"
              @mouseover="hoverCurrentIdx = idx"
              @mouseout="hoverCurrentIdx = -1"
              @click="switchCondition(idx)"
              >
                <div class="search-condition-item-name">
                  {{item.keyName}}
                </div>
              </div>
              <template v-if="item.isActive">
                <!-- <transition name="foldAnimation"> -->
                  <div class="search-condition-item-selectors">
                    <div class="search-selector"
                    v-for="(each, subidx) in item.selectors"
                    :key="subidx"
                    @click="switchSelector(idx, subidx, each, item)"
                    >
                      <i class="search-checkbox" :class="{'is-active': each.isActive}"></i>
                      <span class="search-selector-name">{{each.name}}</span>
                    </div>
                  </div>
                <!-- </transition> -->
              </template>
            </div>
          </div>
        </div>

      </div>

      <p v-if="!isMobile" class="search-bar-tip">* 现展示的学员名单排名不分先后。出于保护学员隐私的需要，我们隐藏了部分学员信息。</p>
    </div>

    <div v-if="isShowSearch" class="btn-box" v-fixed>
      <div class="btn-wrap">
        <div class="btn-cancel" @click="cancel">重置</div>
        <div class="btn-confirm" @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { jobTitles, companyIndustrys, companyScales, companyDevelops } from '@/data/form'

import { getBranchAll } from '@/util/methods'

import service from '@/service'
import VueTypes from 'vue-types'
import lodash from 'lodash'

let params = {
  content: '',
  uid: null,
  job_title: [],
  develop: [],
  scale: [],
  branch_id: [],
  industry: [],
  is_member: null,
  gender: null
}

// 定义 后端的字段与类型
let allConditions = [
  { key: 'branch_id', keyName: '所属地区', inputType: 'checkbox', selectors: [] },
  { key: 'job_title', keyName: '当前职位', inputType: 'checkbox', selectors: jobTitles },
  { key: 'develop', keyName: '开发团队规模', inputType: 'checkbox', selectors: companyDevelops },
  { key: 'scale', keyName: '企业规模', inputType: 'checkbox', selectors: companyScales },
  { key: 'industry', keyName: '行业', inputType: 'checkbox', selectors: companyIndustrys },
  { key: 'is_member', keyName: '是否为董事会成员', inputType: 'radio', selectors: [{ id: true, name: '是' }, { id: false, name: '否' }] },
  { key: 'gender', keyName: '性别', inputType: 'radio', selectors: [{ id: 'M', name: '男' }, { id: 'F', name: '女' }] },
  { key: 'virtual_type', keyName: '是否为名誉会员', inputType: 'radio', selectors: [{ id: 1, name: '是' }, { id: 0, name: '否' }] }
]

allConditions.forEach((item, index) => {
  // 为每一项设置是否显示的初始值
  if (index === 0) item.isActive = true
  else item.isActive = false

  // 为选择的每一项追加是否显示的状态值
  item.selectors.forEach((each) => {
    each['isActive'] = false
  })
})

export default {
  data () {
    return {
      allConditions, // 定义所有条件
      selectedConditions: [], // 当前条件
      params: lodash.cloneDeep(params), // 发送给后端的参数
      hoverCurrentIdx: 0,
      curCurrentidx: 0,
      isShowSearch: false,
      isSearchClass: false,
      results: []
    }
  },
  created () {
    getBranchAll()
      .then(data => {
        data.forEach(item => { item['isActive'] = false })
        allConditions.forEach(item => {
          if (item.key === 'branch_id') item['selectors'] = data
        })
      })
      .catch(err => console.log(err))

    // this.$emit('getData', this.params)
  },
  mounted () {
    var _self = this
    window.addEventListener('scroll', function () {
      if (window.pageYOffset >= 215) {
        _self.isSearchClass = true
      } else {
        _self.isSearchClass = false
      }
    }, false)
    this.setInputUrl()
  },
  props: {
    isMobile: {
      type: Boolean
    },
    barFixed: VueTypes.bool.def(false) // bar 是否fix
  },
  methods: {
    confirm () {
      this.isShowSearch = false
    },
    cancel () {
      this.clearAllCondition()
      this.isShowSearch = false
    },
    /**
     * 控制 search 显示隐藏
     */
    showSearch () {
      this.isShowSearch = !this.isShowSearch
    },
    /**
     * 同步参数
     */
    paramsHandler (idx, subidx, isActive, selector, condition) {
      if (condition.inputType === 'checkbox') {
        if (!isActive) {
          this.params[condition.key].push(selector.id)
          this.$emit('getData', this.params)
        } else {
          let index = this.params[condition.key].findIndex(id => id === selector.id)
          if (index !== -1) {
            this.params[condition.key].splice(index, 1)
            this.$emit('getData', this.params)
          }
        }
      } else {
        if (!isActive) {
          this.params[condition.key] = selector.id
        } else {
          this.params[condition.key] = ''
        }
        this.$emit('getData', this.params)
      }
    },
    /**
     * 选中条件的 Handler
     */
    selectedConditionsHandler (idx, subidx, isActive, selector, condition) {
      if (!isActive) {
        let eachItem = {}
        eachItem['selector'] = Object.assign({}, selector)
        eachItem['key'] = condition.key
        eachItem['idx'] = idx
        eachItem['subidx'] = subidx

        if (condition.inputType === 'radio') {
          this.selectedConditions.forEach((item, index) => {
            if (item.key === condition.key) {
              this.selectedConditions.splice(index, 1)
            }
          })
        }

        if (condition.key === 'is_member') eachItem['selector'].name += '董事会成员'

        this.selectedConditions.unshift(eachItem)
      } else {
        let index = this.selectedConditions.findIndex(item => item.key === condition.key && item.selector.id === selector.id)
        if (index !== -1) this.selectedConditions.splice(index, 1)
      }
    },
    /**
     * 清除所有的条件
     */
    clearAllCondition () {
      this.selectedConditions = []

      this.allConditions.forEach(item => {
        item.selectors.forEach(each => {
          each.isActive = false
        })
      })

      this.params = lodash.cloneDeep(params)

      this.$emit('getData', this.params)
    },
    /**
     * 清除当前的条件
     */
    clearCondition (index) {
      let item = this.selectedConditions[index]

      this.selectedConditions.splice(index, 1)

      this.allConditions[item.idx].selectors[item.subidx].isActive = false

      this.paramsHandler(item.idx, item.subidx, true, this.allConditions[item.idx].selectors[item.subidx], this.allConditions[item.idx])
    },
    /*
     * 是否打开当前筛选条件选项
     */
    switchCondition (idx) {
      if (this.curCurrentidx === idx) {
        this.curCurrentidx = null
      } else {
        this.curCurrentidx = idx
      }
      // this.curCurrentidx = idx

      this.allConditions.forEach((item, index) => {
        if (idx !== index) item.isActive = false
      })

      this.allConditions[idx].isActive = !this.allConditions[idx].isActive
    },
    /**
     * 筛选条件
     */
    switchSelector (idx, subidx, selector, condition) {
      let { isActive } = selector

      if (condition.inputType === 'radio') {
        condition.selectors.forEach(item => {
          item.isActive = false
        })
      }
      selector.isActive = !isActive

      this.selectedConditionsHandler(idx, subidx, isActive, selector, condition)

      this.paramsHandler(idx, subidx, isActive, selector, condition)
    },
    /**
     * 搜索词
     */
    setInputWords ($event) {
      let value = $event.target.value.trim()
      this.params.uid = ''
      this.$router.push({ query: {} }).catch(() => {})
      this.setInput(value)
    },
    setInputUrl () {
      let query = this.$route.query
      let inputUid = Number(query.uid)
      this.params.uid = inputUid
      if (!inputUid) return
      // 需要通过 inputUid 请求拿到name
      this.getMemberInfoName(this.params)
    },
    setInput (value) {
      if (value === this.params.content) return
      this.params.content = value
      this.$emit('onInputWordsChange', this.params)
    },
    // 通过 inputId 请求拿到 对应name
    getMemberInfoName (params) {
      service.getConditionMemberInfo(params)
        .then(data => {
          this.results = data.list[0].name
          this.setInput(this.results)
        })
        .catch(err => console.log(err))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

$bottom-bar-height: 40px;

.search-wrapper {
  width: 92vw;
  margin: 4vw auto 2vw;
  background: #fff;

  &.search-fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    margin: 0;
    padding: 8px 12px;
    background: #fff;
    box-shadow: 0px 6px 12px 1px rgba(0, 0, 0, 0.1);
    z-index: 100;
    .search-input {
      width: 92vw;
      margin: 0 auto;
      padding: 3px 15px;
      border-radius: 16px;
      background: #E9E9E9;
      .input-tag {
        color: #9A9A9A;
        background: #E9E9E9;
      }
    }
  }

  .search-input {
    border: 1px solid rgba(233,233,233,1);
    border-radius: 3px;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    font-size: 14px;

    .iconfont {
      font-size: 15px;
      color: #4a4a4a;
      margin-right: 10px;
    }

    .input-tag {
      flex-grow: 1;
      &::-webkit-input-placeholder {
        font-size: 13px;
        color: #9A9A9A;
      }
      &::-moz-placeholder {/* Firefox 18- */
        font-size: 13px;
        color: #9A9A9A;
      }
      &::-moz-placeholder{/* Firefox 19+ */
        font-size: 13px;
        color: #9A9A9A;
      }
      &::-ms-input-placeholder {
        font-size: 13px;
        color: #9A9A9A;
      }
    }

  }

}

// 搜索部分
.search-bar-wrap {
  width: 315px;
  margin-right: 53px;
  @include mobile {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    // height: 100vh;
    overflow-y: scroll;
    background: #fff;
    border-top: 1px solid #e9e9e9;
    z-index: 100;
    // @include safeAreaBottom;
  }
  &.is-fixed {
    position: fixed;
    top: 40px;
    left: 50%;
    margin-left: -540px;
    z-index: 10000;
  }
}

.search-bar {
  box-shadow: 0px 3px 15px 0px rgba(126,126,126,0.15);
  border-radius: 3px;
  padding: 40px 20px 30px;
  @include mobile {
    box-shadow: none;
    padding-bottom: $bottom-bar-height;
  }
}

.btn-box {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 101;
  width: 100vw;
  // @include safeAreaBottom;
}

.btn-wrap {
  display: flex;
  width: 100%;
  height: $bottom-bar-height;

  .btn-confirm,
  .btn-cancel {
    font-weight: 500;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  .btn-cancel {
    flex: 2;
    color: #4A4A4A;
    background: #F2F2F2;
  }
  .btn-confirm {
    flex: 3;
    color: #fff;
    background: $primary3;
  }
}

.search-input {
  border: 1px solid rgba(233,233,233,1);
  border-radius: 3px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
  .iconfont {
    font-size: 15px;
    color: #4a4a4a;
    margin-right: 10px;
  }
  .input-tag {
    color: #9a9a9a;
    font-size: 12px;
    flex-grow: 1;
    &::-webkit-input-placeholder {
      font-size: 13px;
      color: #9A9A9A;
    }
    &::-moz-placeholder {/* Firefox 18- */
      font-size: 13px;
      color: #9A9A9A;
    }
    &::-moz-placeholder{/* Firefox 19+ */
      font-size: 13px;
      color: #9A9A9A;
    }
    &::-ms-input-placeholder {
      font-size: 13px;
      color: #9A9A9A;
    }
  }
}

// 搜索 bar - title
.search-bar-title {
  margin: 34px 0 28px;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  border-bottom: 1px solid rgba(233,233,233,1);
}

.search-bar-h3 {
  font-size: 18px;
  font-weight: 600;
  color: rgba(74,74,74,1);
  padding-bottom: 12px;
  position: relative;
  &::after {
    position: absolute;
    left: 0;
    bottom: -1px;
    content: '';
    width: 100%;
    height: 3px;
    // border-radius: 2px;
    background-color: $primary3;
  }
}

.search-bar-h4 {
  margin-top: 3px;
  font-size: 14px;
  color: #9A9A9A;
  cursor: pointer;
}

// 搜索 tag
.search-current {}
.search-current-conditions {
  // display: flex;
  // min-height: 120px;
}
.search-current-condition {
  display: inline-flex; align-items: center;
  border: 1px solid #E9E9E9;
  border-radius: 3px;
  padding: 3px 5px 3px 9px;
  margin-right: 14px;
  margin-bottom: 10px;
  line-height: 16px;
  .iconfont {
    font-size: 16px;
    line-height: 16px;
    cursor: pointer;
  }
  &.is-active {
    border: 1px solid $primary3;
    color: $primary3;
    .search-current-name {
      color: $primary3;
    }
  }
}

// 搜索条件
.search-conditions-wrap {
  overflow: hidden;
}
.search-current-name {
  font-size: 14px;
  color: #9A9A9A;
  margin-right: 4px;
  line-height: 16px;
  margin-top: 2px;
}
.search-conditions-bd {
  margin-top: -15px;
}
.search-condition-item {
  position: relative;
  padding: 15px 12px 12px;
  cursor: pointer;
  transition: all 0.2s linear;
  &.is-acitve {
    font-weight: 600;
    @include mobile {
      background: rgba(214, 178, 121, 0.1);
      &::after {
        background: url('./assets/arrow-top.png') no-repeat center / cover;
      }
    }
  }
  &.is-hover {
    background-color: rgba($primary3, 0.1);
    color: $primary3;
    font-weight: 500;
    @include mobile {
      background: none;
      color: inherit;
      font-weight: normal;
    }
  }
  @include mobile {
    padding: 15px 0px 12px;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 6vw;
      width: 3vw;
      height: 2vw;
      transform: translateY(-50%);
      background: url('./assets/arrow-bottom.png') no-repeat center / cover;
    }
  }
}
.search-condition-item-name {
  padding-left: 12px;
  line-height: 16px;
  @include mobile {
      padding-left: 12px;
  }
  &::selection {
    background-color: transparent;
  }
  &::-moz-selection {
    background-color: transparent;
  }
  &::-webkit-selection {
    background-color: transparent;
  }
}
.search-condition-item-selectors {
  // background-color: #fff !important;
}
.search-selector {
  margin-left: 36px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.search-checkbox {
  display: inline-block;
  border: 1px solid rgba($primary3, 0.5);
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 9px;
  margin-top: -1px;
  position: relative;
  &.is-active {
    &::after {
      position: absolute;
      content: '';
      width: 6px;
      height: 6px;
      display: block;
      top: 50%;
      left: 50%;
      background-color: $primary3;
      transform: translate(-50%, -50%);
    }
  }
}
.search-selector-name {
  text-decoration: none;
  &::selection {
    background-color: transparent;
  }
  &::-moz-selection {
    background-color: transparent;
  }
  &::-webkit-selection {
    background-color: transparent;
  }
}

.search-bar-tip {
  padding: 20px;
  font-size: 14px;
  color: rgba(154, 154, 154, 0.8);
}

</style>
